module.exports = __webpack_public_path__ + "img/product-placeholder-17.defca63.png";